import { BASE_URL } from '../components/BaseUrl';

class AbsenceAPI {
  constructor(token) {
    this.token = token;
    this.baseUrl = BASE_URL;
  }

  async _fetch(endpoint, options = {}) {
    const headers = {
      Authorization: `Bearer ${this.token}`,
      'Content-Type': 'application/json',
      ...options.headers,
    };

    try {
      const response = await fetch(`${this.baseUrl}${endpoint}`, {
        ...options,
        headers,
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error(`API Error [${endpoint}]:`, error);
      throw error;
    }
  }

  // Get worker absences
  async getMyAbsences(params = {}) {
    const queryString = new URLSearchParams(
      Object.fromEntries(
        Object.entries(params).filter(([_, v]) => v !== '' && v !== null && v !== undefined)
      )
    ).toString();
    
    return this._fetch(`/absences/worker/absences${queryString ? `?${queryString}` : ''}`, {
      method: 'GET',
    });
  }

  // Get absence calendar
  async getMyAbsenceCalendar(startDate, endDate, viewMode = 'month') {
    const params = new URLSearchParams({
      start_date: startDate,
      end_date: endDate,
      view_mode: viewMode,
    });
    
    return this._fetch(`/absences/worker/absences/calendar?${params}`, {
      method: 'GET',
    });
  }

  // Submit leave request
  async submitLeaveRequest(requestData) {
    return this._fetch(`/requests/v1/requests`, {
      method: 'POST',
      body: JSON.stringify(requestData),
    });
  }

  // Get leave reasons
  async getLeaveReasons() {
    return this._fetch(`/requests/v1/reference/leave-reasons`, {
      method: 'GET',
    });
  }

  // Get my requests
  async getMyRequests(params = {}) {
    const queryString = new URLSearchParams(
      Object.fromEntries(
        Object.entries(params).filter(([_, v]) => v !== '' && v !== null && v !== undefined)
      )
    ).toString();
    
    return this._fetch(`/requests/v1/requests/my${queryString ? `?${queryString}` : ''}`, {
      method: 'GET',
    });
  }

  // Cancel request
  async cancelRequest(requestId) {
    return this._fetch(`/requests/v1/requests/${requestId}/cancel`, {
      method: 'POST',
    });
  }
}

export default AbsenceAPI;
